import CurrencyField from './CurrencyField';

export default CurrencyField;